
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface AccordionItemProps {
  title: React.ReactNode; // Change type to React.ReactNode
  isOpen: boolean;
  onClick: () => void;
  children: React.ReactNode; // Content to render inside the accordion
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, children, isOpen, onClick }) => {
  return (
    <div className="bg-white border-gray-200 my-4 rounded-lg shadow-lg"> {/* Add margin-bottom for spacing */}
  <button
    className={`w-full text-left p-4 text-primary font-bold transition-colors duration-200 
      ${isOpen ? 'bg-primary text-white rounded-t-lg' : 'bg-white rounded-lg'} 
      hover:bg-primary hover:text-white flex items-center justify-between`}
    onClick={onClick}
    style={{ fontFamily: 'Roboto, sans-serif' }} // Apply Roboto font here
  >
    <span>{title}</span>
    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </button>
  {isOpen && <div className="px-4 py-4 bg-gradient-to-b from-white to-[#efefef] rounded-lg">{children}</div>}
</div>

  );
};

export default AccordionItem;
  